import { CALL_API } from "redux-api-middleware";
import api from "apis/preferences";
import {
  REQUEST_SAVE_PREFERENCE,
  RECEIVE_SAVE_PREFERENCE,
  ERROR_SAVE_PREFERENCE,
  REQUEST_LOAD_PREFERENCE,
  RECEIVE_LOAD_PREFERENCE,
  ERROR_LOAD_PREFERENCE,
  REQUEST_LOAD_PREFERENCES,
  RECEIVE_LOAD_PREFERENCES,
  ERROR_LOAD_PREFERENCES
} from "typeConstants";
import responseHandler from "responseHandler";

const savePreference = (code, value, callback) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        endpoint: api.savePreference(),
        method: "POST",
        //passing a strict null to the server allows us to delete a preference through save
        body: JSON.stringify({ code: code, value: value === null ? null : JSON.stringify(value) }),
        types: [
          {
            type: REQUEST_SAVE_PREFERENCE,
            payload: { preferenceCode: code, value: value}
          },
          {
            type: RECEIVE_SAVE_PREFERENCE,
            payload: (action, state, res) => {
                let ret = res.json()
                  .then(data => {
                    return data;
                  });
                if(callback)callback();
                return ret;
              }
          }, {
            type: ERROR_SAVE_PREFERENCE,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const loadPreference = (preferenceCode) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        endpoint: api.loadPreference(preferenceCode),
        method: "GET",
        types: [
          {
            type: REQUEST_LOAD_PREFERENCE,
            payload: preferenceCode
          },
          {
            type: RECEIVE_LOAD_PREFERENCE,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          }, {
            type: ERROR_LOAD_PREFERENCE,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const loadPreferences = (preferenceCodes) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        endpoint: api.loadUserPreferences(),
        method: "POST",
        body: JSON.stringify(preferenceCodes),
        types: [
          {
            type: REQUEST_LOAD_PREFERENCES,
            payload: preferenceCodes
          },
          {
            type: RECEIVE_LOAD_PREFERENCES,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          }, {
            type: ERROR_LOAD_PREFERENCES,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

//only returns true if the preference was just loaded from the internet (checks for a change in isFetching)
const preferenceJustLoaded = (code, oldPrefs, newPrefs) => {
  return (oldPrefs.hasOwnProperty(code) && oldPrefs[code].isFetching && newPrefs.hasOwnProperty(code) && !newPrefs[code].isFetching);
};

//checks if the preference value changes for any reason (value can change if someone else saves it because saves update preferences in the global store)
const preferenceValueChanged = (code, oldPrefs, newPrefs) => {
  return (oldPrefs.hasOwnProperty(code) ? oldPrefs[code].value : null) != (newPrefs.hasOwnProperty(code) ? newPrefs[code].value : null);
};

export {
  savePreference,
  loadPreference,
  loadPreferences,
  preferenceJustLoaded,
  preferenceValueChanged
};